import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams } from "react-router-dom";
import blogPosts from "../../data/blogPosts";

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center">
        <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">
          Article not found
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mt-2 mb-6">
          The post you are looking for does not exist.
        </p>
        <Link
          to="/blog"
          className="inline-flex items-center min-h-[44px] px-2 gap-2 rounded-full text-brand-600 dark:text-brand-400 font-semibold hover:text-brand-700 dark:hover:text-brand-500 transition-colors"
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Back to blog
        </Link>
      </div>
    );
  }

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Link
        to="/blog"
        className="inline-flex items-center gap-2 mr-1 text-sm font-semibold text-gray-500 dark:text-gray-400 hover:text-brand-500 transition-colors mb-8"
      >
        <FontAwesomeIcon icon={faArrowLeft} /> Back to blog
      </Link>

      <span className="inline-block text-xs font-bold uppercase tracking-wide text-brand-600 dark:text-brand-400 bg-brand-100 dark:bg-brand-700 dark:bg-opacity-40 px-3 py-1 rounded-full mb-4">
        {post.tag}
      </span>
      <h1 className="text-3xl sm:text-5xl font-black tracking-tight text-gray-900 dark:text-white leading-tight">
        {post.title}
      </h1>
      <div className="mt-4 text-sm text-gray-400">
        By {post.author} · {post.date} · {post.readTime}
      </div>

      <img
        src={post.cover}
        alt={post.title}
        className="w-full h-64 sm:h-96 object-cover rounded-3xl mt-8"
      />

      <div className="mt-8 space-y-6">
        {post.content.map((para, i) => (
          <p
            key={i}
            className="text-lg leading-relaxed text-gray-700 dark:text-gray-300"
          >
            {para}
          </p>
        ))}
      </div>

      <div className="mt-12 pt-8 border-t border-gray-100 dark:border-gray-800">
        <Link
          to="/photos"
          className="inline-flex items-center gap-2 bg-brand-500 hover:bg-brand-600 text-white font-semibold px-6 py-3 rounded-full transition-colors"
        >
          Browse free photos
        </Link>
      </div>
    </article>
  );
};

export default BlogPost;
